import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface LeaderboardPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function LeaderboardPagination({ 
  currentPage, 
  totalPages, 
  onPageChange 
}: LeaderboardPaginationProps) {
  return (
    <div className="flex justify-center items-center gap-2">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="p-2 rounded-lg bg-gray-800 text-amber-200 disabled:opacity-50"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>

      <span className="text-amber-200">
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="p-2 rounded-lg bg-gray-800 text-amber-200 disabled:opacity-50"
      >
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  );
}